module.exports = __webpack_public_path__ + "static/media/5.f2cbb702.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/5.png
// module id = 468
// module chunks = 0